'use client';
var IDENT = "BaseButton";
var defaultProps = {
    type: "button",
    contentGap: "2s"
};

export { IDENT, defaultProps };
